import type { Group, ScheduleType } from '../types';

interface DashboardFiltersProps {
  groups: Group[];
  selectedGroupId: string | null;
  selectedShift: ScheduleType | null;
  onGroupChange: (groupId: string | null) => void;
  onShiftChange: (shift: ScheduleType | null) => void;
  onClearFilters: () => void;
}

export function DashboardFilters({
  groups,
  selectedGroupId,
  selectedShift,
  onGroupChange,
  onShiftChange,
  onClearFilters,
}: DashboardFiltersProps) {
  const hasActiveFilters = selectedGroupId || selectedShift;

  return (
    <div className="bg-white rounded-lg shadow px-2 py-3">
      <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-3 md:space-y-0">
        <div className="sm:flex items-center space-x-2 hidden ps-3">
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span className="text-sm font-medium text-gray-700">Filters:</span>
        </div>

        <div className="flex-1 grid grid-cols-2 md:grid-cols-2 gap-3 md:pe-3 pe-0">
          {/* Group Filter */}
          <div>
            <select
              value={selectedGroupId || ''}
              onChange={(e) => onGroupChange(e.target.value || null)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            >
              <option value="">All Groups</option>
              {groups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </select>
          </div>

          {/* Shift Filter */}
          <div>
            <select
              value={selectedShift || ''}
              onChange={(e) => onShiftChange((e.target.value as ScheduleType) || null)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            >
              <option value="">All Shifts</option>
              <option value="fullday">Full Day</option>
              <option value="day">Day Shift</option>
              <option value="night">Night Shift</option>
              <option value="off">Off</option>
            </select>
          </div>
        </div>

        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
}
